import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { retrieveCMSdata } from "../../services/CustomerService";
import Loader from "../Loader";

const AboutUs = () => {
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState(false)

  let cmsId = 1;

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  const getData = async () => {
    setloading(true)
    await retrieveCMSdata()
      .then((response) => {
    setloading(false);
        let cmsData = response?.data?.data?.find((x) => x?.id === cmsId);

        setdata(cmsData?.description);
      })
      .catch((error) => {
            setloading(false);

        console.log("Error", error);
      });
  };

  return (
    <main className="main pages">
      <div className="page-header breadcrumb-wrap">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/" rel="nofollow">
              <i className="fi-rs-home mr-5" />
              Home
            </Link>
            <span /> About us
          </div>
        </div>
      </div>
      <div className="page-content pt-50">
        <div className="container">
          <div className="row">
            <div className="col-xl-10 col-lg-12 m-auto">
              <section className="row align-items-center mb-50">
                <div className="col-lg-12">
                  <div className="pl-25">
                    <h2 className="mb-30">About Us</h2>
                    <div className="mb-50">
                      {!loading ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data,
                          }}
                        />
                      ) : (
                        <Loader />
                      )}
                    </div>
                     {/* <p className="mb-25">
                      N2N Solutions was established with the
                      principles of Honesty, courtesy, Sincerity and plain
                      simple excellent customer service. We at N2N Solutions strongly
                      believe in, “Treating people as you like to be treated.”
                      We are committed to providing you with the
                      best products and excellent service in our industry. Our goal is to
                      provide high quality products for lowest price possible to
                      all of our customers.
                    </p>
                   
                    <p className="mb-30">
                      To Place an order, request a free catalog or get a
                      password to visit our site, call our-sales department at{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        contact us{" "}
                      </span>{" "}
                      or email us at{" "}
                      <a
                        // className="contact-email"
                        className="contact-web"
                        href="mailto:info@n2nsolution.co"
                      >
                        info@n2nsolution.co
                      </a>
                    </p>

                    <p className="mb-10">Thank you for visiting</p>

                    <p className="mb-50">
                      <a
                        className="contact-web"
                        target="_blank"
                        href="#"
                      >
                        {" "}
                        N2N Solutions
                      </a>
                    </p>  */}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AboutUs;
